import { KeyOf } from '~/types';
import { colors } from './colors';
import { themeColorDark, themeColorLight } from './themeColor';

export const contentLight = {
  main_1: themeColorLight.main_1,
  hierarchy1: colors.neutral800,
  hierarchy2: colors.neutral600,
  hierarchy3: colors.neutral400,
  hierarchy1_reverse: colors.white,
  hierarchy2_reverse: colors.neutral20,
  hierarchy3_reverse: colors.neutral40,
  caption1: colors.neutral300,
  caption2: colors.neutral100,
  btn_disabled: colors.blackAlpha10,

  content_light_1: '#FFFFFF',
  content_light_2: '#EFEFF0',
  content_light_3: '#CFCFD3',
  content_light_4: '#AFAFB6',
  content_light_5: colors.whiteAlpha40,
  content_dark_1: '#303036',
  content_dark_2_alpha: colors.blackAlpha60,
  content_dark_3_alpha: colors.blackAlpha40,
} as const;

export const contentDark: Content = {
  main_1: themeColorDark.main_1,
  hierarchy1: colors.white,
  hierarchy2: colors.neutral20,
  hierarchy3: colors.neutral40,
  hierarchy1_reverse: colors.neutral800,
  hierarchy2_reverse: colors.neutral600,
  hierarchy3_reverse: colors.neutral400,
  caption1: colors.neutral50,
  caption2: colors.neutral200,
  btn_disabled: colors.whiteAlpha10,

  content_light_1: '#FFFFFF',
  content_light_2: '#EFEFF0',
  content_light_3: '#CFCFD3',
  content_light_4: '#AFAFB6',
  content_light_5: colors.whiteAlpha40,
  content_dark_1: '#303036',
  content_dark_2_alpha: colors.blackAlpha60,
  content_dark_3_alpha: colors.blackAlpha40,
};

export type Content = typeof contentLight;
export type ContentKeys = KeyOf<typeof contentLight>;
